import { Links } from '@/shared/constants/navegacao';

function pathMatchesPrefix(pathname: string, base: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

export function isNavItemActive(pathname: string, search: string, to: string): boolean {
  const q = to.indexOf('?');
  const pathOnly = q >= 0 ? to.slice(0, q) : to;
  const queryPart = q >= 0 ? to.slice(q + 1) : '';

  if (pathOnly === Links.Folhas_Por_Mes) {
    if (pathname !== Links.Folhas_Por_Mes) return false;
    if (!queryPart) return true;
    const expected = new URLSearchParams(queryPart);
    const actual = new URLSearchParams(search.replace(/^\?/, ''));
    return [...expected.entries()].every(([key, value]) => actual.get(key) === value);
  }

  if (pathOnly === Links.Atividades_Pendentes) {
    return pathname === Links.Atividades_Pendentes;
  }

  if (pathOnly === Links.Movimentacoes_Lista) {
    return pathname === Links.Movimentacoes_Lista;
  }

  if (pathOnly === Links.Relatorio_Movimentacoes) {
    return pathname === Links.Relatorio_Movimentacoes;
  }

  if (pathOnly === Links.Movimentacoes_Index) {
    return (
      pathMatchesPrefix(pathname, Links.Movimentacoes_Index) ||
      pathMatchesPrefix(pathname, Links.Movimentacoes_Criar) ||
      pathMatchesPrefix(pathname, Links.Movimentacoes_Editar)
    );
  }

  if (pathOnly === Links.Movimentacoes_Tipos_Index) {
    return (
      pathMatchesPrefix(pathname, Links.Movimentacoes_Tipos_Index) ||
      pathMatchesPrefix(pathname, Links.Movimentacoes_Tipos_Criar) ||
      pathMatchesPrefix(pathname, Links.Movimentacoes_Tipos_Editar)
    );
  }

  if (q >= 0) {
    if (pathname !== pathOnly) return false;
    if (!queryPart) return true;
    const expected = new URLSearchParams(queryPart);
    const actual = new URLSearchParams(search.replace(/^\?/, ''));
    return [...expected.entries()].every(([key, value]) => actual.get(key) === value);
  }

  return pathname === pathOnly || pathname.startsWith(`${pathOnly}/`);
}
